export default {"src":"/_next/static/media/download-app-store.cbb2a97c.svg","height":67,"width":183,"blurWidth":0,"blurHeight":0};